import { Family } from 'src/clients/hooks/useFamily';

export function filterAndOrderFamilies(
  families: Family[],
  term: string,
  preselectFamilyId?: string,
): Family[] {
  const base = term
    ? families.filter(family => family.name.toLowerCase().includes(term))
    : families;

  if (!preselectFamilyId) return base;

  return [...base].sort((a, b) => {
    if (a.id === preselectFamilyId) return -1;
    if (b.id === preselectFamilyId) return 1;
    return 0;
  });
}
